var _rect, _rect2, _text, _text2, _text3, _circle, _circle2, _circle3, _circle4, _path, _path2, _path3, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBigSale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 340,
    height: 160,
    viewBox: "0 0 340 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 340,
    height: 160,
    rx: 12,
    fill: "url(#paint0_linear)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 324,
    height: 144,
    rx: 8,
    stroke: "#FFFFFF",
    strokeWidth: 2,
    strokeDasharray: "8 4"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 60,
    fontFamily: "Arial, sans-serif",
    fontWeight: 900,
    fontSize: 36,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "BIG SALE")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 100,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700,
    fontSize: 32,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "UPTO 50% OFF")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 170,
    y: 130,
    fontFamily: "Arial, sans-serif",
    fontSize: 14,
    fill: "#FFFFFF",
    textAnchor: "middle"
  }, "Limited time offer")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 10,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 30,
    r: 10,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 130,
    r: 10,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 310,
    cy: 130,
    r: 10,
    fill: "#FFFFFF",
    opacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M280 50L285 55L280 60L275 55L280 50Z",
    fill: "#FFFFFF",
    opacity: 0.6
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60 50L65 55L60 60L55 55L60 50Z",
    fill: "#FFFFFF",
    opacity: 0.6
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M280 100L285 105L280 110L275 105L280 100Z",
    fill: "#FFFFFF",
    opacity: 0.6
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M60 100L65 105L60 110L55 105L60 100Z",
    fill: "#FFFFFF",
    opacity: 0.6
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 0,
    y1: 0,
    x2: 340,
    y2: 160,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#FF6B6B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF9E53"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigSale);
export default __webpack_public_path__ + "static/media/big_sale.95106ac8963d69633a3d602e96280af5.svg";
export { ForwardRef as ReactComponent };